import { combineReducers } from "@reduxjs/toolkit";
import loginReducer from "./LoginPage/LoginReducer";
import GetUserReducer from "./GetUser/GetUserReducer";
import ForgotAndResetPasswordReducer from "./ForgotAndResetPassword/ForgotAndResetPasswordReducer";
import EmployeeListReducer from "./Employees/EmployeeReducer";
import SampleListReducer from "./Sample/SampleReducer";
import ChangePasswordReducer from "./ChangePassword/ChangePasswordReducer";
import CountryListReducer from "./CountryState/Country/CountryReducer";
import StateListReducer from "./CountryState/State/StateReducer";
import CronSettingReducer from "./CronSettings/CronSettingsReducer";
import BlockListListReducer from "./Blocklist/BlocklistReducer";
import VisitorLogReducer from "./VisitorLogs/VisitorLogsReducer";
import MasterReducer from "./Master/MasterReducer";
import DashboardReducer from "./Dashboard/DashboardReducer";
import SettingsReducer from "./Settings/SettingsReducer";

const rootReducer = combineReducers({
  loginReducer: loginReducer,
  cronSettingReducer: CronSettingReducer,
  blockListListReducer: BlockListListReducer,
  visitorLogReducer: VisitorLogReducer,
  user: GetUserReducer,
  forgotAndResetPasswordReducer: ForgotAndResetPasswordReducer,
  employee: EmployeeListReducer,
  sample: SampleListReducer,
  changePassword: ChangePasswordReducer,
  country: CountryListReducer,
  state: StateListReducer,
  masterReducer: MasterReducer,
  dashboardReducer: DashboardReducer,
  settingsReducer: SettingsReducer,
});

export default rootReducer;
